<template>
  <router-view />
</template>

<script>
export default {
  name: "PhotosPage",
  breadcrumb: {
    title: "Фото",
    to: "/photos"
  }
};
</script>
